import React, { useCallback, useEffect, useState } from 'react';
import { PrinterOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Flex, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  AButton,
  PageIntro,
  PageLayout,
  PagePanel,
  StatusActive,
} from '../../../../../components';
import { useToast } from '../../../../../hooks/toast';
import api from '../../../../../services/api';
import { IClient } from '../../../../../shared/interfaces';

const ClientReportList: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<IClient[]>([]);

  const loadReport = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/clients/reports/list');
      setClients(response.data.data || response.data);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Erro ao carregar o relatório de Clientes',
      });
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  const columns = [
    {
      title: 'Código',
      dataIndex: 'code',
      width: 100,
    },
    {
      title: 'Nome',
      dataIndex: 'corporate_name',
    },
    {
      title: 'CPF/CNPJ',
      dataIndex: 'cpf_cnpj',
    },
    {
      title: 'Celular',
      dataIndex: 'cell_phone',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 80,
      render: (value: boolean) => <StatusActive status={value} />,
    },
  ];

  return (
    <PageLayout>
      <PageIntro
        badge="Relatórios"
        icon={<PrinterOutlined />}
        title="Lista de clientes"
        description="Consulte o cadastro completo de clientes em uma visualização padronizada para impressão e conferência."
        actions={
          <Flex>
            <AButton
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/clients')}
            >
              Voltar
            </AButton>
            <AButton
              type="primary"
              icon={<PrinterOutlined />}
              onClick={() => navigate('/clients/reports/list/print')}
            >
              Imprimir
            </AButton>
          </Flex>
        }
      />
      <PagePanel>
        <Table
          dataSource={clients}
          columns={columns}
          rowKey="id"
          pagination={false}
          loading={loading}
          bordered
          size="small"
        />
      </PagePanel>
    </PageLayout>
  );
};

export default ClientReportList;
